"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalanceResponseMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class AccountBalanceResponseMapper {
    toDomain(result) {
        const guestAvailableBalance = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.balanceInformation.guestAvailableBalance");
        const guestAllowedBalance = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.balanceInformation.guestAllowedBalance");
        const isBalanceLoading = result.loading;
        return {
            balance: guestAvailableBalance,
            allowedBalance: guestAllowedBalance,
            isBalanceLoading,
        };
    }
}
exports.AccountBalanceResponseMapper = AccountBalanceResponseMapper;
